import { ReportHandler } from "web-vitals";
import * as Sentry from "@sentry/react";

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Send Web Vitals to Sentry
export function sendWebVitalsToSentry() {
  reportWebVitals((metric) => {
    // Send Core Web Vitals to Sentry as custom metrics
    Sentry.addBreadcrumb({
      category: "web-vitals",
      message: `${metric.name}: ${metric.value}`,
      level: "info",
      data: {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      },
    });

    // Also send as a measurement for performance monitoring
    Sentry.setMeasurement(metric.name, metric.value, "millisecond");
  });
}

export default reportWebVitals;
